var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"55\" alt=\"\"><br><br><div style=\"width: 240px;\"><h3>You can accept or reject the applicant and send appropriate notifications by clicking here.</h3></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/tour/intro/step3.jade
// module id = 825
// module chunks = 0